module.exports = "//a.spikex.com/sigma/frontend-ssr-web-index/_next/static/images/new-9a72340479456067a8a988ed799e8ec4.png";